/* eslint-disable */

import React, { Component } from 'react';
import _ from 'lodash';

import logo from './logo.svg';

// Styles
// CoreUI Icons Set

// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application

import './scss/style.css'


import {
  Input,
  Form,
  FormGroup,
  Badge,
  Button,
  ButtonDropdown,
  ButtonGroup,
  ButtonToolbar,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Progress,
  Row,
  Table,
} from 'reactstrap';

import ReactSpeedometer from "react-d3-speedometer"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 	faLightbulb, 
			faLightbulbSlash,
			faUserAlt,
			faUserAltSlash,
			faBell,
			faTrain,
			faChevronDoubleLeft,
			faChevronDoubleRight,
			faChevronDoubleUp,
			faChevronDoubleDown,
			faVolumeUp,
			faSpinner
			 } from '@fortawesome/pro-light-svg-icons'

import { 	faOctagon, 
			} from '@fortawesome/pro-solid-svg-icons'


import db from './firebase';

class TrainControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
		train: null,
		dropdownOpen: false
    };
    
    
    this.toggleSoundDropdown = this.toggleSoundDropdown.bind(this);
    
  }
  
  
  componentDidMount() {
    // Updating the `someData` local state attribute when the Firebase Realtime Database data
    // under the '/someData' path changes.
    this.firebaseRef = db.database().ref('/train');
    var that = this;
    this.firebaseCallback = this.firebaseRef.on('value', (snap) => {
	    
	    that.setState({train: snap.val()});
	});    
  }
  
  componentWillUnmount() {
    // Un-register the listener on '/someData'.
    this.firebaseRef.off('value', this.firebaseCallback);
   
  }
  
  toggle(key, newstate) {
	  var that = this;
	  return function() {
		  var obj = {};
		  obj[key] = newstate;
		  console.log (key, newstate);
		  that.firebaseRef.update(obj);
		  that.setState({dropdownOpen: false})
	  }
  }
  
  toggleSoundDropdown() {

    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }



  render() {
  	const that = this;
	const train = this.state.train;  
	
	if (!train) { //loading
	
		return (<div style={{top: 300, position: 'relative'}}>
					<FontAwesomeIcon icon={faSpinner} spin />
					<br />
					Loading ... 
				</div>);	
	}
	
	
	/*
	
	FRONT_LIGHT
	CHOO
	DING
	VOICE
	LOADING_NOISES
	BACKGROUND_NOISE
	BACKGROUND_NOISE_2
	NOISE_CHHHHH
	NOISE_CHHHHH_2
	NOISE_CHUGGA_CHUGGA
	NOISE_SHORT_CHOO
	CABIN_LIGHT
	*/
	
	var trainTableStyle = {maxWidth: '500px', width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 5};
	
    return (
      <div className="App">
        <div className="App-header" style={{height: 100}}>
          <img src='https://imif-2020.s3.ap-southeast-2.amazonaws.com/imagineif_logo_master_retina.png' alt="logo" style={{maxWidth: 200, maxHeight: 80}} />
          <h2>Burnside Train Controller</h2>
        </div>
        <p className="App-intro">
        
        <table style={trainTableStyle} >
        <tr style={{borderTop: '12px solid transparent', borderBottom: '12px solid transparent'}}>
        	<td style={{width: 100, fontSize: '0.8em'}}><FontAwesomeIcon icon={faLightbulb} size="lg" /><br />Lights</td>
        	<td style={{display: 'flex', justifyContent: 'space-evenly'}} >
				
				<Button 
					flex={1}
					color={train.FRONT_LIGHT ? 'success' : 'secondary'} 
					onClick={this.toggle('FRONT_LIGHT', !train['FRONT_LIGHT'])}>
						Front Light
				</Button> 
				
				<Button
					flex={1}
					color={train.CABIN_LIGHT ? 'success' : 'secondary'} 
					onClick={this.toggle('CABIN_LIGHT', !train['CABIN_LIGHT'])}>
						Cabin Light
				</Button>
			</td>
		</tr>
		<tr>
        	<td style={{width: 100, fontSize: '0.8em'}}><FontAwesomeIcon icon={faVolumeUp} size="lg" /><br />Sounds</td>
        	<td style={{display: 'flex', justifyContent: 'space-evenly', borderTop: '1px soilid grey'}} >
        		<Button 
        			flex={1}
		          	color={train.DING ? 'success' : 'secondary'} 
		          	onClick={this.toggle('DING', !train['DING'])}>
		          		Bell
		          </Button>
		        
		        <Button 
		        	flex={1}
		          	color={train.NOISE_SHORT_CHOO ? 'success' : 'secondary'} 
		          	onClick={this.toggle('NOISE_SHORT_CHOO', !train['NOISE_SHORT_CHOO'])}>
		          		Whistle
		          </Button>
		        
		          
		        <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleSoundDropdown}>
					<DropdownToggle caret>
						Other Sounds
					</DropdownToggle>
					<DropdownMenu>
						
						<DropdownItem onClick={this.toggle('VOICE', !train['VOICE'])}>Conductor&apos;s call</DropdownItem>
						<DropdownItem onClick={this.toggle('LOADING_NOISES', !train['LOADING_NOISES'])}>Cargo Loading</DropdownItem>
						
						<DropdownItem onClick={this.toggle('CHOO', !train['CHOO'])}>Long whistle</DropdownItem>
						
					</DropdownMenu>
				</ButtonDropdown>
		        
        	</td>
        </tr>
        <tr>
        	<td style={{width: 100, fontSize: '0.8em'}}><FontAwesomeIcon icon={faTrain} size="lg" /><br />Driving</td>
        	<td>
        		
        		<ReactSpeedometer
					maxValue={50}
					fludWidth={true}
					value={train.speed}
					needleColor="black"
					startColor="yellow"
					segments={600}
					maxSegmentLabels={6}
					width={190}
					height={120}
					ringWidth={20}
					endColor="red"
					currentValueText="${value} km/h"

					/>
				<div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingBottom: 20}} >
					<Button 
						flex={1}
						style={{height: '38px'}}
			          	color={'secondary'} 
			          	onClick={this.toggle('speed', (train.speed - 1 < 0) ? 0 : (train.speed - 1))}>
			          		<FontAwesomeIcon icon={faChevronDoubleDown} size="lg" />
			          </Button>
			          
			        <Button 
						flex={1}
						style={{height: '80px'}}
			          	color={train.speed ? 'danger' : 'secondary'} 
			          	onClick={this.toggle('speed', 0)}>
			          		<FontAwesomeIcon icon={faOctagon} size="lg" /> STOP
			          </Button>
			        
			        <Button 
			        	flex={1}
			        	style={{height: '38px', touchAction: 'none'}}
			          	color={'secondary'} 
			          	onClick={this.toggle('speed', (train.speed < 50 ? train.speed + 1 : train.speed))}>
			          		<FontAwesomeIcon icon={faChevronDoubleUp} size="lg" />
			          </Button>
			          
			    </div>

				<div style={{display: 'flex', justifyContent: 'space-evenly'}} >
					
	        		<Button 
	        			flex={1}
			          	color={train.direction == 'backward' ? 'success' : 'secondary'} 
			          	onClick={this.toggle('direction', 'backward')}>
			          		<FontAwesomeIcon icon={faChevronDoubleLeft} size="lg" /> Reverse
			          </Button>
			        <Button 
			        	flex={1}
			          	color={train.direction == 'forward' ? 'success' : 'secondary'} 
			          	onClick={this.toggle('direction', 'forward')}>
			          		Forwards <FontAwesomeIcon icon={faChevronDoubleRight} size="lg" />
			          </Button>
				</div>
				
				
				
        	</td>
        </tr>
        
        
		</table>
          
          <br />
          
           
          
          
          
          
          
        </p>
      </div>
    );
  }
}

export default TrainControl;



// WEBPACK FOOTER //
// ./src/TrainControl.js